// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root___8JwA","tab":"Tabs_tab__6nJ7m","tabActive":"Tabs_tabActive__3issW"};